import * as SentrySDK from '@sentry/browser';
import { ContextLines, ExtraErrorData } from "@sentry/integrations";

const Sentry = {
  debug: false,
  attachStacktrace: true,

  init: (dsn, environment, secondaryDsn) => SentrySDK.init({
    dsn: dsn,
    debug: Sentry.debug,
    attachStacktrace: Sentry.attachStacktrace,
    environment: environment,
    integrations: [
      new ContextLines(),
      new ExtraErrorData(),
    ],
    // With a secondary DSN every envelope is sent to both Sentry instances, used during a migration between them.
    transport: secondaryDsn
      ? SentrySDK.makeMultiplexedTransport(SentrySDK.makeFetchTransport, () => [dsn, secondaryDsn])
      : undefined,
  }),
};

Object.freeze(Sentry);
window.Sentry = window.Sentry || Sentry;
